import DashView from "./components/Dash.vue";
import LoginView from "./components/Login.vue";
import NotFoundView from "./components/404.vue";

// Import Views - Dash
import ProjectView from "./components/views/Project.vue";
import AccessoryView from "./components/views/Accessory.vue";
import AgentView from "./components/views/Agent.vue";
import DeviceView from "./components/views/Device.vue";
import InformationView from "./components/views/Information.vue";
import DeviceTypesView from "./components/views/DeviceTypes.vue";
import DeviceAddonView from "./components/views/DeviceAddon.vue";
import DeviceAddonClientView from "./components/views/DeviceAddonClient.vue";
import ApnsRelationView from "./components/views/ApnsRelation.vue";
import OAuth2List from "./components/views/OAuth2List.vue";
import Domain from "./components/views/Domain.vue";
import AddAppView from "./components/views/AddApp.vue";
import AboutDeviceView from "./components/views/AboutDevice.vue";
import ParameterSetting from "./components/views/ParameterSetting.vue";
import EventList from "./components/views/EventList.vue";
import DeviceUpgrade from "./components/views/DeviceUpgrade.vue";
import DeviceLog from "./components/views/DeviceLog.vue";
import ProblemDeviceList from "./components/views/ProblemDeviceList.vue";
import DeviceUser from "./components/views/DeviceUser.vue";
import FeedbackView from "./components/views/Feedback.vue";
import RobotListView from "./components/views/RobotList.vue";
import MasterView from "./components/views/Master.vue";
import AndroidView from "./components/views/Android.vue";
import IosView from "./components/views/Ios.vue";
import GeneralSetting from "./components/views/GeneralSetting.vue";
import TestDeviceAnalysisView from "./components/views/TestDeviceAnalysis.vue";
import ConnectionAnalysisView from "./components/views/ConnectionAnalysis.vue";
import MobileClientsUpdateLogs from "./components/views/MobileClientsUpdateLogs.vue";
import MasterSlavesUpdateLogs from "./components/views/MasterSlavesUpdateLogs.vue";
import DinNewsWeekly from "./components/views/DinNewsWeekly.vue";

// Routes
const routes = [
  {
    path: "/login",
    component: LoginView
  },
  {
    path: "/",
    component: DashView,
    children: [
      {
        path: "project",
        alias: "",
        component: ProjectView,
        name: "Project",
        meta: {
          description: "Project List",
          requiresAuth: true
        }
      },
      {
        path: "accessory",
        component: AccessoryView,
        name: "Accessory",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "agent",
        component: AgentView,
        name: "Agent",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "device",
        component: DeviceView,
        name: "Device",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "aboutdevice",
        component: AboutDeviceView,
        name: "AboutDevice",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "parametersetting",
        component: ParameterSetting,
        name: "ParameterSetting",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "eventlist",
        component: EventList,
        name: "EventList",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "deviceupgrade",
        component: DeviceUpgrade,
        name: "DeviceUpgrade",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "devicelog",
        component: DeviceLog,
        name: "DeviceLog",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "problemdevicelist",
        component: ProblemDeviceList,
        name: "ProblemDeviceList",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "deviceuser",
        component: DeviceUser,
        name: "DeviceUser",
        meta: { description: "", requiresAuth: true }
      },
      // {
      //   path: "information*",
      //   component: InformationView,
      //   name: "Information",
      //   meta: { description: "", requiresAuth: true }
      // },
      {
        path: "information/app",
        component: InformationView,
        name: "Information",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "information/devicetypes",
        component: DeviceTypesView,
        name: "DeviceTypes",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "information/deviceaddon",
        component: DeviceAddonView,
        name: "DeviceAddon",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "information/deviceaddonclient",
        component: DeviceAddonClientView,
        name: "DeviceAddonClient",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "information/apnsrelation",
        component: ApnsRelationView,
        name: "ApnsRelation",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "oauth2",
        component: OAuth2List,
        name: "OAuth2List",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "domain",
        component: Domain,
        name: "Domain",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "addapp",
        component: AddAppView,
        name: "AddApp",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "feedback",
        component: FeedbackView,
        name: "Feedback",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/compilation/robotlist",
        component: RobotListView,
        name: "RobotList",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/compilation/master",
        component: MasterView,
        name: "Master",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/compilation/generalsetting",
        component: GeneralSetting,
        name: "generalsetting",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/analysis/testdeviceanalysis",
        component: TestDeviceAnalysisView,
        name: "TestDeviceAnalysis",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/analysis/connection",
        component: ConnectionAnalysisView,
        name: "connnectionAnalysis",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/compilation/mobileclientsupdatelogs",
        component: MobileClientsUpdateLogs,
        name: "mobileClientsUpdateLogs",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/compilation/masterslavesupdatelogs",
        component: MasterSlavesUpdateLogs,
        name: "masterSlavesUpdateLogs",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/compilation/android",
        component: AndroidView,
        name: "Android",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/compilation/ios",
        component: IosView,
        name: "Ios",
        meta: { description: "", requiresAuth: true }
      },
      {
        path: "/dinnewsweekly",
        component: DinNewsWeekly,
        name: "Dinnewsweekly",
        meta: { description: "", requiresAuth: true }
      }
    ]
  },
  {
    // not found handler
    path: "*",
    component: NotFoundView
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js